import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React from 'react';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { Container, Grid, TAGLink, TAGTypography } from '../../';
import { default as FocalPointImage } from './FocalPointImage';

var RichText = function RichText(_ref) {
  var _renderNode;

  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'white' : _ref$backgroundColor,
      _ref$centerAlign = _ref.centerAlign,
      centerAlign = _ref$centerAlign === void 0 ? false : _ref$centerAlign,
      _ref$contained = _ref.contained,
      contained = _ref$contained === void 0 ? false : _ref$contained,
      content = _ref.content,
      _ref$contentMaxWidth = _ref.contentMaxWidth,
      contentMaxWidth = _ref$contentMaxWidth === void 0 ? '1200px' : _ref$contentMaxWidth,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth;
  var textAlign = centerAlign ? 'center' : 'left';
  var RICH_TEXT_OPTIONS = {
    renderNode: (_renderNode = {}, _defineProperty(_renderNode, BLOCKS.HEADING_1, function (_, children) {
      return React.createElement(TAGTypography, {
        variant: "h1",
        color: "text.primary",
        sx: {
          margin: '10px 0'
        }
      }, children);
    }), _defineProperty(_renderNode, BLOCKS.HEADING_2, function (_, children) {
      return React.createElement(TAGTypography, {
        variant: "h2",
        color: "text.primary",
        sx: {
          margin: '12px 0'
        }
      }, children);
    }), _defineProperty(_renderNode, BLOCKS.HEADING_3, function (_, children) {
      return React.createElement(TAGTypography, {
        variant: "h3",
        color: "text.primary",
        sx: {
          margin: '14px 0'
        }
      }, children);
    }), _defineProperty(_renderNode, BLOCKS.HEADING_4, function (_, children) {
      return React.createElement(TAGTypography, {
        variant: "h4",
        color: "text.primary",
        sx: {
          margin: '16px 0'
        }
      }, children);
    }), _defineProperty(_renderNode, BLOCKS.EMBEDDED_ASSET, function (node) {
      var _node$data$target, _node$data$target2, _node$data$target3, _node$data$target$des, _node$data$target4;

      // NOTE: non-fullWidth height has not been designed
      return ((_node$data$target = node.data.target) === null || _node$data$target === void 0 ? void 0 : _node$data$target.file.contentType) === 'text/html' ? React.createElement("iframe", {
        width: fullWidth ? '700' : '350',
        height: fullWidth ? '394' : '200',
        src: "https://www.youtube.com/embed/".concat((_node$data$target2 = node.data.target) === null || _node$data$target2 === void 0 ? void 0 : _node$data$target2.filename),
        title: node.data.target.description,
        frameBorder: 0,
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true
      }) : React.createElement("img", {
        src: (_node$data$target3 = node.data.target) === null || _node$data$target3 === void 0 ? void 0 : _node$data$target3.file.url,
        alt: (_node$data$target$des = (_node$data$target4 = node.data.target) === null || _node$data$target4 === void 0 ? void 0 : _node$data$target4.description) !== null && _node$data$target$des !== void 0 ? _node$data$target$des : ''
      });
    }), _defineProperty(_renderNode, BLOCKS.EMBEDDED_ENTRY, function (node) {
      var _node$data$target5, _node$data$target6, _node$data$target7;

      return React.createElement(FocalPointImage, {
        image: (_node$data$target5 = node.data.target) === null || _node$data$target5 === void 0 ? void 0 : _node$data$target5.image,
        focalPoint: (_node$data$target6 = node.data.target) === null || _node$data$target6 === void 0 ? void 0 : _node$data$target6.focalPoint
      }, (_node$data$target7 = node.data.target) === null || _node$data$target7 === void 0 ? void 0 : _node$data$target7.children);
    }), _defineProperty(_renderNode, BLOCKS.PARAGRAPH, function (_, children) {
      return React.createElement("p", null, React.createElement(TAGTypography, {
        variant: "bodyMediumBook",
        color: "text.secondary"
      }, children));
    }), _defineProperty(_renderNode, INLINES.HYPERLINK, function (node, children) {
      return React.createElement(TAGLink, {
        href: node.data.uri,
        variant: "bodyMediumBook",
        color: "text.link"
      }, children);
    }), _defineProperty(_renderNode, INLINES.ENTRY_HYPERLINK, function (node, children) {
      var _node$data$target8;

      return React.createElement(TAGLink, {
        href: (_node$data$target8 = node.data.target) === null || _node$data$target8 === void 0 ? void 0 : _node$data$target8.path,
        variant: "bodyMediumBook",
        color: "text.link"
      }, children);
    }), _renderNode)
  };
  return contained ? React.createElement(Grid, {
    item: true,
    sx: {
      backgroundColor: "backgrounds.".concat(backgroundColor),
      textAlign: textAlign
    }
  }, renderRichText(content, RICH_TEXT_OPTIONS)) : fullWidth ? React.createElement(Grid, {
    sx: {
      backgroundColor: "backgrounds.".concat(backgroundColor)
    }
  }, React.createElement(Container, {
    sx: {
      textAlign: textAlign,
      maxWidth: {
        md: contentMaxWidth
      }
    }
  }, renderRichText(content, RICH_TEXT_OPTIONS))) : React.createElement(Container, {
    sx: {
      backgroundColor: "backgrounds.".concat(backgroundColor),
      textAlign: textAlign,
      maxWidth: {
        md: contentMaxWidth
      }
    }
  }, renderRichText(content, RICH_TEXT_OPTIONS));
};

export default RichText;